
(function ($, document) {

    $(document).on('click', '.toggle-switch__option', function (e) {
        e.preventDefault();

        var $control = $(this).parent('.toggle-switch__control');

        $control
            .find('.toggle-switch__option.toggle-switch__option--active')
            .addClass('toggle-switch__option--inactive2')
            .removeClass('toggle-switch__option--active')
            ;

        $control
            .find('.toggle-switch__option.toggle-switch__option--inactive')
            .addClass('toggle-switch__option--active')
            .removeClass('toggle-switch__option--inactive')
            ;

        $control
            .find('.toggle-switch__option.toggle-switch__option--inactive2')
            .addClass('toggle-switch__option--inactive')
            .removeClass('toggle-switch__option--inactive2')
            ;

        $control
            .find('.toggle-switch__switch')
            .toggleClass('toggle-switch__switch--right')
            ;

        $control
            .find('input[type=hidden][data-toggle-switch-selected-option]')
            .val(
                $control
                    .find('.toggle-switch__option.toggle-switch__option--active')
                    .data('option')
        );

        if ($control.data('link-only')) {
            window.location.href = $control
                .find('.toggle-switch__option.toggle-switch__option--active')
                .attr('href')
            ;
        }

        if (typeof UpdatePage_HasChanged == 'function')
        {
            UpdatePage_HasChanged();
        }
    });

    $(document).on('click', '.toggle-switch__switch', function (e) {
        e.preventDefault();

        var $control = $(this).parent('.toggle-switch__control');

        $control
            .find('.toggle-switch__option.toggle-switch__option--inactive')
            .trigger('click')
        ;
    });

})(jQuery, document);